import { Pipe, PipeTransform } from '@angular/core'
import { environment } from 'src/environments/environment'
import { LocaleCode } from '../interfaces/locale'
import { MBTI } from '../interfaces/mbti'
import { LocaleService } from '../services/locale/locale-service'

@Pipe({
  name: 'mbtiLink',
})
export class MbtiLinkPipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(value: MBTI | undefined): string {
    if (value) {
      if (this.localeService.isKo) {
        return `https://www.16personalities.com/ko/성격유형-${value}`
      } else if (this.localeService.locale === LocaleCode.zhHant) {
        return `https://www.16personalities.com/tw/${value}-性格`
      } else if (this.localeService.locale === LocaleCode.ja) {
        return `https://www.16personalities.com/ja/${value}型の性格`
      } else {
        return `https://www.16personalities.com/${value}-personality`
      }
    }
    return environment.webUrl
  }
}
